import { render } from "./ClinicSchedule.vue?vue&type=template&id=1b353b9e&scoped=true"
import script from "./ClinicSchedule.vue?vue&type=script&lang=js"
export * from "./ClinicSchedule.vue?vue&type=script&lang=js"

import "./ClinicSchedule.vue?vue&type=style&index=0&id=1b353b9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b353b9e"]])

export default __exports__